import QRCode from "qrcode";

/**
 * Render any string payload as a QR PNG data URL — the one place the dashboard's QR options live, so every QR
 * on screen (PIX / Bre-B collection codes, card deposit addresses) scans the same way. Returns null on
 * failure, which callers treat as non-fatal.
 */
export async function qrDataUrl(payload: string): Promise<string | null> {
  try {
    return await QRCode.toDataURL(payload, { errorCorrectionLevel: "M", margin: 1, width: 512 });
  } catch {
    return null;
  }
}
